/* eslint-disable @typescript-eslint/ban-ts-comment */
import { interpolate } from "flubber";
import React, { RefObject } from "react";
import { Animated, Easing, Platform, StyleProp, ViewStyle } from "react-native";
import SVG_Svg, { G as SVG_G, Path as SVG_Path, Text, TSpan } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

const Path = Animated.createAnimatedComponent(SVG_Path);
const G = Animated.createAnimatedComponent(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);
/***/

/**
 *
 *  /$$$$$$                               /$$$$$$$  /$$
 * |_  $$_/                              | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$       | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$      | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$      | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$      | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  __  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |$$| |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 */

/*
 * ORIGINAL SVG - STATE 0
 * ---------------------------------
 * <svg width="1345" height="132" viewBox="0 0 1345 132" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE"></desc>
 * <g id="status=received">
 * <rect id="Rectangle 1" x="50" y="32" width="1245" height="36" fill="#D8D8D8"/>
 * <rect id="Progress Track" x="50" y="34" width="7" height="32" fill="#32B31E"/>
 * <circle id="Ellipse 3" cx="50" cy="50" r="50" fill="#38C721"/>
 * <path id="Check 1" fill-rule="evenodd" clip-rule="evenodd" d="M74.8233 38.0389L44.4278 67.3489L26 50.0728L30.7876 44.9661L44.3598 57.69L69.9643 33L74.8233 38.0389Z" fill="white"/>
 * <circle id="Ellipse 4" cx="1295" cy="50" r="50" fill="#C4C4C4"/>
 * <circle id="Ellipse 5" cx="880" cy="50" r="50" fill="#C4C4C4"/>
 * <circle id="Ellipse 6" cx="465" cy="50" r="50" fill="#C4C4C4"/>
 * <text id="Received" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="8.80566" y="130.652">RECEIVED</tspan></text>
 * <text id="APPROVED" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="418.655" y="130.652">APPROVED</tspan></text>
 * <text id="Shipped" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="842.937" y="130.652">SHIPPED</tspan></text>
 * <text id="Delivered" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="1248.96" y="130.652">DELIVERED</tspan></text>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 1
 * ---------------------------------
 * <svg width="1345" height="130" viewBox="0 0 1345 130" fill="none" xmlns="http://www.w3.org/2000/svg">
 * <g id="status=approved">
 * <rect id="Rectangle 1" x="50" y="32" width="1245" height="36" fill="#D8D8D8"/>
 * <rect id="Progress Track" x="50" y="34" width="426" height="32" fill="#32B31E"/>
 * <circle id="Ellipse 3" cx="50" cy="50" r="50" fill="#38C721"/>
 * <circle id="Ellipse 4" cx="1295" cy="50" r="50" fill="#C4C4C4"/>
 * <circle id="Ellipse 5" cx="880" cy="50" r="50" fill="#C4C4C4"/>
 * <circle id="Ellipse 6" cx="465" cy="50" r="50" fill="#38C721"/>
 * <path id="Check 1" fill-rule="evenodd" clip-rule="evenodd" d="M74.8233 38.0389L44.4278 67.3489L26 50.0728L30.7876 44.9661L44.3598 57.69L69.9643 33L74.8233 38.0389Z" fill="white"/>
 * <path id="Check 2" fill-rule="evenodd" clip-rule="evenodd" d="M489.823 38.0389L459.428 67.3489L441 50.0728L445.788 44.9661L459.36 57.69L484.964 33L489.823 38.0389Z" fill="white"/>
 * <text id="APPROVED" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="418.655" y="128.652">APPROVED</tspan></text>
 * <text id="Shipped" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="842.937" y="128.652">SHIPPED</tspan></text>
 * <text id="Delivered" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="1248.96" y="128.652">DELIVERED</tspan></text>
 * <text id="Received" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="8.80566" y="128.652">RECEIVED</tspan></text>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 2
 * ---------------------------------
 * <svg width="1345" height="130" viewBox="0 0 1345 130" fill="none" xmlns="http://www.w3.org/2000/svg">
 * <g id="status=shipped">
 * <rect id="Rectangle 1" x="50" y="32" width="1245" height="36" fill="#D8D8D8"/>
 * <rect id="Progress Track" x="50" y="34" width="832" height="32" fill="#32B31E"/>
 * <circle id="Ellipse 3" cx="50" cy="50" r="50" fill="#38C721"/>
 * <circle id="Ellipse 4" cx="1295" cy="50" r="50" fill="#C4C4C4"/>
 * <circle id="Ellipse 5" cx="880" cy="50" r="50" fill="#38C721"/>
 * <circle id="Ellipse 6" cx="465" cy="50" r="50" fill="#38C721"/>
 * <path id="Check 1" fill-rule="evenodd" clip-rule="evenodd" d="M74.8233 38.0389L44.4278 67.3489L26 50.0728L30.7876 44.9661L44.3598 57.69L69.9643 33L74.8233 38.0389Z" fill="white"/>
 * <path id="Check 2" fill-rule="evenodd" clip-rule="evenodd" d="M489.823 38.0389L459.428 67.3489L441 50.0728L445.788 44.9661L459.36 57.69L484.964 33L489.823 38.0389Z" fill="white"/>
 * <path id="Check 3" fill-rule="evenodd" clip-rule="evenodd" d="M906.823 38.0389L876.428 67.3489L858 50.0728L862.788 44.9661L876.36 57.69L901.964 33L906.823 38.0389Z" fill="white"/>
 * <text id="APPROVED" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="420.655" y="128.652">APPROVED</tspan></text>
 * <text id="Shipped" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="844.937" y="128.652">SHIPPED</tspan></text>
 * <text id="Delivered" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="1250.96" y="128.652">DELIVERED</tspan></text>
 * <text id="Received" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="10.8057" y="128.652">RECEIVED</tspan></text>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 3
 * ---------------------------------
 * <svg width="1345" height="131" viewBox="0 0 1345 131" fill="none" xmlns="http://www.w3.org/2000/svg">
 * <g id="status=delivered">
 * <rect id="Rectangle 1" x="50" y="32" width="1245" height="36" fill="#D8D8D8"/>
 * <rect id="Progress Track" x="50" y="34" width="1245" height="32" fill="#32B31E"/>
 * <circle id="Ellipse 3" cx="50" cy="50" r="50" fill="#38C721"/>
 * <circle id="Ellipse 4" cx="1295" cy="50" r="50" fill="#38C721"/>
 * <circle id="Ellipse 5" cx="880" cy="50" r="50" fill="#38C721"/>
 * <circle id="Ellipse 6" cx="465" cy="50" r="50" fill="#38C721"/>
 * <path id="Check 1" fill-rule="evenodd" clip-rule="evenodd" d="M74.8233 38.0389L44.4278 67.3489L26 50.0728L30.7876 44.9661L44.3598 57.69L69.9643 33L74.8233 38.0389Z" fill="white"/>
 * <path id="Check 2" fill-rule="evenodd" clip-rule="evenodd" d="M489.823 38.0389L459.428 67.3489L441 50.0728L445.788 44.9661L459.36 57.69L484.964 33L489.823 38.0389Z" fill="white"/>
 * <path id="Check 3" fill-rule="evenodd" clip-rule="evenodd" d="M906.823 38.0389L876.428 67.3489L858 50.0728L862.788 44.9661L876.36 57.69L901.964 33L906.823 38.0389Z" fill="white"/>
 * <path id="Check 4" fill-rule="evenodd" clip-rule="evenodd" d="M1319.82 38.0389L1289.43 67.3489L1271 50.0728L1275.79 44.9661L1289.36 57.69L1314.96 33L1319.82 38.0389Z" fill="white"/>
 * <text id="APPROVED" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="420.655" y="129.652">APPROVED</tspan></text>
 * <text id="Shipped" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="844.937" y="129.652">SHIPPED</tspan></text>
 * <text id="Delivered" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="1250.96" y="129.652">DELIVERED</tspan></text>
 * <text id="Received" fill="black" xml:space="preserve" style="white-space: pre" font-family="Roboto" font-size="18" font-weight="bold" letter-spacing="0em"><tspan x="10.8057" y="129.652">RECEIVED</tspan></text>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"morph": {
 * 		"condition": "props.morph",
 * 		"targets": {
 * 			"status=received": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			},
 * 			"status=approved": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			},
 * 			"status=shipped": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			},
 * 			"status=delivered": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			}
 * 		},
 * 		"numStates": 4
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: StyleProp<ViewStyle>;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: unknown;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  status?: "received" | "approved" | "shipped" | "delivered";
  onAnimationComplete?: () => void;
};
/***/

/** Morphing Types */

type tMorphRef = Animated.WithAnimatedValue<React.Ref<React.Component<unknown, unknown, unknown>>> &
  React.Ref<React.Component<unknown, unknown, unknown>>;
type tPathRef = typeof Path & {
  // Native Control
  setNativeProps: ({ d }: { d: string }) => void; // Web Control

  _touchableNode: {
    setAttribute: (attr: string, val: string) => void;
  }; // Get Ids

  props: {
    id: string;
  };
};
type tMorphProps = {
  morphConfigProgress_20Trackd: string | Animated.AnimatedInterpolation;
  morphConfigEllipse_204fill: string | Animated.AnimatedInterpolation;
  morphConfigEllipse_205fill: string | Animated.AnimatedInterpolation;
  morphConfigEllipse_206fill: string | Animated.AnimatedInterpolation;
  morphConfigCheck_202opacity: string | Animated.AnimatedInterpolation;
  morphConfigCheck_203opacity: string | Animated.AnimatedInterpolation;
  morphConfigCheck_204opacity: string | Animated.AnimatedInterpolation;
  morphConfigAPPROVED_elem0x: string | Animated.AnimatedInterpolation;
  morphConfigAPPROVED_elem0y: string | Animated.AnimatedInterpolation;
  morphConfigShipped_elem0x: string | Animated.AnimatedInterpolation;
  morphConfigShipped_elem0y: string | Animated.AnimatedInterpolation;
  morphConfigDelivered_elem0x: string | Animated.AnimatedInterpolation;
  morphConfigDelivered_elem0y: string | Animated.AnimatedInterpolation;
  morphConfigReceived_elem0x: string | Animated.AnimatedInterpolation;
  morphConfigReceived_elem0y: string | Animated.AnimatedInterpolation;
  bindInterpolation: tMorphRef;
};
/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const OrderStatusBar = (props: {
  style?: StyleProp<ViewStyle>;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: unknown;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  status?: "received" | "approved" | "shipped" | "delivered";
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const { svgRef, maxSegmentLength = 1, onAnimationComplete = () => 0 } = props;
  /** Component Internal State */

  const [morphState] = React.useState<{
    morphAnimVal: Animated.Value;
    morphProps: tMorphProps;
  }>({
    morphAnimVal: new Animated.Value(0),
    morphProps: {
      bindInterpolation: () => undefined,
      morphConfigProgress_20Trackd: "M50 34 H57 V66 H50 V34z",
      morphConfigEllipse_204fill: "C4C4C4",
      morphConfigEllipse_205fill: "C4C4C4",
      morphConfigEllipse_206fill: "C4C4C4",
      morphConfigCheck_202opacity: "0",
      morphConfigCheck_203opacity: "0",
      morphConfigCheck_204opacity: "0",
      morphConfigAPPROVED_elem0x: "418.655",
      morphConfigAPPROVED_elem0y: "130.652",
      morphConfigShipped_elem0x: "842.937",
      morphConfigShipped_elem0y: "130.652",
      morphConfigDelivered_elem0x: "1248.96",
      morphConfigDelivered_elem0y: "130.652",
      morphConfigReceived_elem0x: "8.80566",
      morphConfigReceived_elem0y: "130.652",
    },
  });
  /** End Custom React-Hooks */

  /** Morph Wrapper */

  type tMorphProperty = {
    status: "received" | "approved" | "shipped" | "delivered";
  };
  type tMorphProperties = {
    [key: string]: tMorphProperty;
  };
  const morphStates: tMorphProperties = {
    0: {
      status: "received",
    },
    1: {
      status: "approved",
    },
    2: {
      status: "shipped",
    },
    3: {
      status: "delivered",
    },
  };

  function getNextMorphState(): number {
    const { status, morph = 0 } = props;
    let nextState = morph;
    Object.keys(morphStates).forEach((possibleMorphState) => {
      if (morphStates[possibleMorphState].status === status) {
        nextState = parseInt(possibleMorphState, 10);
      }
    });
    return nextState;
  }

  const { morphAnimVal, morphProps } = morphState;

  const currValueRef = React.useRef(0);
  const nextValue: number = getNextMorphState() ?? 3;
  const currValue = currValueRef.current;
  let startValue = Math.floor(currValue);
  let endValue = Math.ceil(nextValue);

  if (currValue > nextValue) {
    startValue = Math.ceil(currValue);
    endValue = Math.floor(nextValue);
  }
  /**
   * Normalize an input to a range of 0 to 1
   */

  const normalize = (x: number, bound1: number, bound2: number) =>
    Number((x - Math.min(bound1, bound2)) / (Math.max(bound1, bound2) - Math.min(bound1, bound2)));
  /**
   * Custom Hook to Control Animation Interpolation of SVG Paths
   */

  const useGenerateMorphInterpolation = (
    interpolations: Array<{
      morphId: keyof tMorphProps;
      paths: string[];
    }>,
    start: number,
    end: number,
  ) => {
    const refs = React.useRef<Record<string, tPathRef>>({});
    React.useEffect(() => {
      const interpolators: {
        [morphId: string]: {
          initial: string;
          final: string;
          interpolator: (t: number) => string;
        };
      } = {};
      interpolations.forEach(({ morphId, paths }) => {
        const initial = paths[start];
        const final = paths[end];
        const p1 = start > end ? final : initial;
        const p2 = start > end ? initial : final;
        const interpolator = interpolate(p1, p2, {
          maxSegmentLength,
        });
        interpolators[morphId] = {
          initial,
          final,
          interpolator,
        };
      });

      const onValueChange = ({ value }: { value: number }) => {
        Object.keys(interpolators).forEach((morphId) => {
          const { final, interpolator } = interpolators[morphId];
          let nextInterpolatedPath: string;

          if (value % 1 === 0) {
            nextInterpolatedPath = final;
          } else {
            nextInterpolatedPath = interpolator(normalize(value, start, end));
          }

          if (morphId in refs.current) {
            const thisRef = refs.current[morphId];

            if (Platform.OS === "web") {
              thisRef?._touchableNode?.setAttribute("d", nextInterpolatedPath);
            } else {
              thisRef?.setNativeProps({
                d: nextInterpolatedPath,
              });
            }
          }
        });
      };

      const listenerId = morphAnimVal.addListener(onValueChange);
      return () => morphAnimVal.removeListener(listenerId); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [start, end]);
    return (((ref: tPathRef) => {
      const id = ref?.props?.id ?? "unknown";

      if (refs && refs.current) {
        refs.current[`morphConfig${id}d`] = ref;
      }
    }) as unknown) as tMorphRef;
  };

  morphProps.bindInterpolation = useGenerateMorphInterpolation(
    [
      {
        morphId: "morphConfigProgress_20Trackd",
        paths: [
          "M50 34 H57 V66 H50 V34z",
          "M50 34 H476 V66 H50 V34z",
          "M50 34 H882 V66 H50 V34z",
          "M50 34 H1295 V66 H50 V34z",
        ],
      },
    ],
    startValue,
    endValue,
  );
  const morphValues: {
    [id: string]: Array<string>;
  } = {
    morphConfigEllipse_204fill: ["#C4C4C4", "#C4C4C4", "#C4C4C4", "#38C721"],
    morphConfigEllipse_205fill: ["#C4C4C4", "#C4C4C4", "#38C721", "#38C721"],
    morphConfigEllipse_206fill: ["#C4C4C4", "#38C721", "#38C721", "#38C721"],
    morphConfigCheck_202opacity: ["0", "1", "1", "1"],
    morphConfigCheck_203opacity: ["0", "0", "1", "1"],
    morphConfigCheck_204opacity: ["0", "0", "0", "1"],
    morphConfigAPPROVED_elem0x: ["418.655", "418.655", "420.655", "420.655"],
    morphConfigAPPROVED_elem0y: ["130.652", "128.652", "128.652", "129.652"],
    morphConfigShipped_elem0x: ["842.937", "842.937", "844.937", "844.937"],
    morphConfigShipped_elem0y: ["130.652", "128.652", "128.652", "129.652"],
    morphConfigDelivered_elem0x: ["1248.96", "1248.96", "1250.96", "1250.96"],
    morphConfigDelivered_elem0y: ["130.652", "128.652", "128.652", "129.652"],
    morphConfigReceived_elem0x: ["8.80566", "8.80566", "10.8057", "10.8057"],
    morphConfigReceived_elem0y: ["130.652", "128.652", "128.652", "129.652"],
  };

  function clamp(lower: number, upper: number, v: number) {
    let r = v;

    if (r > upper) {
      r = upper;
    } else if (r < lower) {
      r = lower;
    }

    return r;
  }

  function getInterpolationRange(
    morphId: string,
    start: number,
    end: number,
  ): {
    inputRange: number[];
    outputRange: string[];
  } {
    const initial = clamp(0, 4, start);
    const final = clamp(0, 4, end);
    const inputRange = [start, end];
    const outputRange = [morphValues[morphId][initial], morphValues[morphId][final]];

    if (start > end) {
      inputRange.reverse();
      outputRange.reverse();
    }

    return {
      inputRange,
      outputRange,
    };
  }

  morphProps.morphConfigEllipse_204fill = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigEllipse_204fill", startValue, endValue),
  );
  morphProps.morphConfigEllipse_205fill = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigEllipse_205fill", startValue, endValue),
  );
  morphProps.morphConfigEllipse_206fill = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigEllipse_206fill", startValue, endValue),
  );
  morphProps.morphConfigCheck_202opacity = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigCheck_202opacity", startValue, endValue),
  );
  morphProps.morphConfigCheck_203opacity = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigCheck_203opacity", startValue, endValue),
  );
  morphProps.morphConfigCheck_204opacity = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigCheck_204opacity", startValue, endValue),
  );
  morphProps.morphConfigAPPROVED_elem0x = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigAPPROVED_elem0x", startValue, endValue),
  );
  morphProps.morphConfigAPPROVED_elem0y = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigAPPROVED_elem0y", startValue, endValue),
  );
  morphProps.morphConfigShipped_elem0x = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigShipped_elem0x", startValue, endValue),
  );
  morphProps.morphConfigShipped_elem0y = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigShipped_elem0y", startValue, endValue),
  );
  morphProps.morphConfigDelivered_elem0x = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigDelivered_elem0x", startValue, endValue),
  );
  morphProps.morphConfigDelivered_elem0y = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigDelivered_elem0y", startValue, endValue),
  );
  morphProps.morphConfigReceived_elem0x = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigReceived_elem0x", startValue, endValue),
  );
  morphProps.morphConfigReceived_elem0y = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigReceived_elem0y", startValue, endValue),
  );
  React.useEffect(() => {
    const forwardMorph = [
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 500,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
    ];

    const restartAnimation = () => {
      const nextInt = Math.ceil(nextValue);

      if (nextInt in forwardMorph) {
        forwardMorph[nextInt]?.start(() => {
          currValueRef.current = nextInt;
          onAnimationComplete();
        });
      }
    };

    if (morphAnimVal && morphAnimVal.stopAnimation) {
      morphAnimVal.stopAnimation(restartAnimation);
    } else {
      restartAnimation();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextValue]);
  /** End Morph Wrapper */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 1345 132" fill="none" id="svg_root" ref={svgRef as RefObject<unknown>} {...props}>
      <G id="status_3Dreceived">
        <Path
          id="Rectangle_201"
          fill="#D8D8D8"
          d="M50 32 H1295 V68 H50 V32z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
        />
        <Path
          id="Progress_20Track"
          fill="#32B31E"
          d="M50 34 H57 V66 H50 V34z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
        />
        <Path
          id="Ellipse_203"
          fill="#38C721"
          d="M100 50 A50 50 0 0 1 50 100 A50 50 0 0 1 0 50 A50 50 0 0 1 100 50z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
        />
        <Path
          id="Check_201"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.8233 38.0389L44.4278 67.3489L26 50.0728L30.7876 44.9661L44.3598 57.69L69.9643 33L74.8233 38.0389Z"
          fill="white"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
        />
        <Path
          id="Ellipse_204"
          d="M1345 50 A50 50 0 0 1 1295 100 A50 50 0 0 1 1245 50 A50 50 0 0 1 1345 50z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          fill={morphProps.morphConfigEllipse_204fill}
        />
        <Path
          id="Ellipse_205"
          d="M930 50 A50 50 0 0 1 880 100 A50 50 0 0 1 830 50 A50 50 0 0 1 930 50z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          fill={morphProps.morphConfigEllipse_205fill}
        />
        <Path
          id="Ellipse_206"
          d="M515 50 A50 50 0 0 1 465 100 A50 50 0 0 1 415 50 A50 50 0 0 1 515 50z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          fill={morphProps.morphConfigEllipse_206fill}
        />
        <Text id="Received" fill="black" fontFamily="Roboto" fontSize={18} fontWeight="bold" letterSpacing="0em">
          <TSpan
            id="Received_elem0"
            // @ts-ignore
            x={morphProps.morphConfigReceived_elem0x}
            // @ts-ignore
            y={morphProps.morphConfigReceived_elem0y}
          >
            {"RECEIVED"}
          </TSpan>
        </Text>
        <Text id="APPROVED" fill="black" fontFamily="Roboto" fontSize={18} fontWeight="bold" letterSpacing="0em">
          <TSpan
            id="APPROVED_elem0"
            // @ts-ignore
            x={morphProps.morphConfigAPPROVED_elem0x}
            // @ts-ignore
            y={morphProps.morphConfigAPPROVED_elem0y}
          >
            {"APPROVED"}
          </TSpan>
        </Text>
        <Text id="Shipped" fill="black" fontFamily="Roboto" fontSize={18} fontWeight="bold" letterSpacing="0em">
          {/* @ts-ignore */}
          <TSpan id="Shipped_elem0" x={morphProps.morphConfigShipped_elem0x} y={morphProps.morphConfigShipped_elem0y}>
            {"SHIPPED"}
          </TSpan>
        </Text>
        <Text id="Delivered" fill="black" fontFamily="Roboto" fontSize={18} fontWeight="bold" letterSpacing="0em">
          <TSpan
            id="Delivered_elem0"
            // @ts-ignore
            x={morphProps.morphConfigDelivered_elem0x}
            // @ts-ignore
            y={morphProps.morphConfigDelivered_elem0y}
          >
            {"DELIVERED"}
          </TSpan>
        </Text>
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          id="Check_202"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          fill-rule={"evenodd"}
          clip-rule={"evenodd"}
          fill={"white"}
          opacity={morphProps.morphConfigCheck_202opacity}
          d={"M489.823 38.0389L459.428 67.3489L441 50.0728L445.788 44.9661L459.36 57.69L484.964 33L489.823 38.0389Z"}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          id="Check_203"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          fill-rule={"evenodd"}
          clip-rule={"evenodd"}
          fill={"white"}
          opacity={morphProps.morphConfigCheck_203opacity}
          d={"M906.823 38.0389L876.428 67.3489L858 50.0728L862.788 44.9661L876.36 57.69L901.964 33L906.823 38.0389Z"}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          id="Check_204"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          fill-rule={"evenodd"}
          clip-rule={"evenodd"}
          fill={"white"}
          opacity={morphProps.morphConfigCheck_204opacity}
          d={"M1319.82 38.0389L1289.43 67.3489L1271 50.0728L1275.79 44.9661L1289.36 57.69L1314.96 33L1319.82 38.0389Z"}
        />
      </G>
    </Svg>
  );
};
/***/

export default OrderStatusBar;
